import React, { Component } from 'react'
import {
  Checkbox,
  FormControlLabel,
  Paper,
} from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import { getAccent, hexToRgba } from './constants'

export class PrivilegeListRow extends Component {
  render () {
    const child = this.props.childData || {}
    const { classes = {}, themecolors = {} } = this.props
    const checked = !!child.checked
    const accent = getAccent(themecolors)
    const bg = themecolors.backgroundColor || themecolors.white || '#fff'
    const text = themecolors.textColor || '#344054'
    const label = this.props.translate(
      child.key === 'position' ? 'unit' + child.key : child.key
    )

    return (
      <Paper
        elevation={0}
        sx={{
          px: 1,
          py: 0.5,
          borderRadius: '8px',
          border: '1px solid',
          borderColor: checked
            ? hexToRgba(accent, 0.35)
            : hexToRgba(accent, 0.1),
          backgroundColor: checked ? hexToRgba(accent, 0.08) : bg,
          transition: 'border-color 0.15s ease, background-color 0.15s ease',
          '&:hover': {
            borderColor: hexToRgba(accent, 0.4),
            backgroundColor: hexToRgba(accent, 0.05),
          },
        }}
      >
        <FormControlLabel
          sx={{
            m: 0,
            width: '100%',
            alignItems: 'center',
            '& .MuiFormControlLabel-label': {
              fontSize: 13,
              lineHeight: 1.35,
              color: text,
            },
          }}
          control={
            <Checkbox
              size="small"
              checked={checked}
              onChange={e => this.props.handleChange(e, 'child', child)}
              disabled={child.key === 'account'}
              classes={{
                root: classes.root,
                checked: classes.checked,
                disabled: classes.disabled,
              }}
              sx={{
                color: accent,
                '&.Mui-checked': { color: accent },
              }}
            />
          }
          label={
            <Tooltip title={child.description || label || ''}>
              <span>{label}</span>
            </Tooltip>
          }
        />
      </Paper>
    )
  }
}

export const ListRow = PrivilegeListRow

export default PrivilegeListRow
